import { SignUpParams, ValidateSignUpStageParams } from '../api/interfaces';
import { SignUpStep } from '../enums';
import { Fields } from '../redux/slices/signUpSlice';

export const prepareRecruiterSignUpDataByStep = (fields: Fields, step: SignUpStep): ValidateSignUpStageParams => {
    switch (step) {
        case SignUpStep.RegistrationInfo:
            return {
                email: fields.email,
                password: fields.password,
                name: fields.name,
                phone: fields.phone,
                agreeTerms: fields.agreeTerms,
                validate: true,
            };
        case SignUpStep.CompanyInfo:
            return {
                type: fields.recruiterType,
                agencyName: fields.agencyName,
                cityId: fields.city?.id || null,
                validate: true,
            };

        case SignUpStep.Countries:
            return {
                countriesIds: fields.countries.map((c) => c.id),
                validate: true,
            };

        case SignUpStep.Areas:
            return {
                areasIds: fields.areas.map((a) => a.id),
                validate: true,
            };
        default:
            console.error(`Invalid step ${step} provided!`);
            return {
                validate: true,
            };
    }
};

export const prepareRecruiterSignUpData = (fields: Fields): SignUpParams => {
    return {
        email: fields.email,
        password: fields.password,
        name: fields.name,
        phone: fields.phone,
        agreeTerms: fields.agreeTerms,
        type: fields.recruiterType,
        agencyName: fields.agencyName,
        cityId: fields.city?.id as unknown as string,
        countriesIds: fields.countries.map((c) => c.id),
        areasIds: fields.areas.map((a) => a.id),
        emailCode: fields.emailCode,
    };
};
